var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRanks = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 43,
  viewBox: "0 0 38 43",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.405,
  cy: 29.709,
  rx: 13.745,
  ry: 13.291,
  fill: "#C7A77B"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.09 0a.68.68 0 0 0-.594.358.666.666 0 0 0 .054.685L13.62 16.222l6.248-8.503L14.395.27a.678.678 0 0 0-.54-.269H3.09ZM26.57.862a.678.678 0 0 0-.54.27L14.9 16.28a13.228 13.228 0 0 1 4.735-.861c2.314-.05 4.627.51 6.67 1.566.14.068.279.14.415.214L37.876 1.905a.666.666 0 0 0 .053-.685.68.68 0 0 0-.593-.358H26.57Z",
  fill: "#EBE4DA"
})));
export default SvgRanks;